exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assign-user-btn[data-v-7c453b5f] {\n  border-radius: 25px !important;\n}\n", ""]);

// exports
